import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';

import FlightSearchResults from 'components/FlightSearchResults';

import Query, {
  PackageDateAddFlightDialogQuery,
} from '__generated__/PackageDateAddFlightDialogQuery.graphql';
import { useDialog } from 'components/Dialog';

type Props = {
  packageDateID: string;
  queryRef: PreloadedQuery<PackageDateAddFlightDialogQuery>;
};

const PackageDateAddFlightDialogSearchResults: FC<Props> = props => {
  const { packageDateID, queryRef } = props;
  const { close } = useDialog();

  const { flightsSearch } = usePreloadedQuery<PackageDateAddFlightDialogQuery>(
    Query,
    queryRef
  );

  return (
    <FlightSearchResults
      id={packageDateID}
      results={flightsSearch}
      onAdd={close}
    />
  );
};

export default PackageDateAddFlightDialogSearchResults;
